module.exports = __webpack_public_path__ + "static/media/open-menu.4a9a687c.svg";